/*
 * klaviyo-overlay-fix.js
 *
 * Защита от бага сторонней формы Klaviyo: при закрытии полноэкранного попапа
 * (кнопка X, ссылка "No thanks", клик по фону, Esc) Klaviyo иногда НЕ убирает
 * за собой:
 *   1. невидимый backdrop-оверлей  — position:fixed; z-index:90000; opacity:0;
 *      но pointer-events:auto на весь экран → перехватывает ВСЕ клики;
 *   2. класс <body class="klaviyo-prevent-body-scrolling"> → скролл заблокирован.
 *
 * В итоге после закрытия попапа страница (карточка товара и др.) становится
 * "мёртвой" — ничего не нажимается и не скроллится.
 *
 * Klaviyo — внешняя зависимость (мы не правим её код). Этот watchdog
 * самостоятельно лечит застрявшее состояние: пока на <body> висит класс
 * блокировки скролла, он следит, открыта ли реально форма; как только форма
 * закрылась, а класс/оверлей остались — снимает их.
 *
 * Срабатывает ТОЛЬКО на время жизни попапа (нет постоянного polling).
 */
(function () {
  'use strict';

  var LOCK_CLASS = 'klaviyo-prevent-body-scrolling';

  // Реально ли на экране видна форма Klaviyo (открыта)?
  //
  // ВАЖНО: проверяем ТОЛЬКО внешние слои-обёртки (FULLSCREEN/POPUP/FLYOUT/BANNER),
  // у которых opacity отражает видимость. Внутренний "modal-form-container"
  // НЕ годится: после закрытия Klaviyo оставляет его opacity:1 + полный размер
  // (видимость гасится прозрачностью родителя), и детект ложно считал бы форму
  // открытой → уборка никогда бы не запустилась.
  function klFormOpen() {
    var nodes = document.querySelectorAll(
      '[data-testid="FULLSCREEN"],' +
      '[data-testid="POPUP"],' +
      '[data-testid="FLYOUT"],' +
      '[data-testid="BANNER"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var s = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      if (
        s.display !== 'none' &&
        s.visibility !== 'hidden' &&
        parseFloat(s.opacity) > 0.1 &&
        r.width > 100 &&
        r.height > 100
      ) {
        return true;
      }
    }
    return false;
  }

  // Убрать застрявший backdrop + разблокировать скролл.
  function cleanup() {
    if (klFormOpen()) return; // форма действительно открыта — не трогаем

    if (document.body.classList.contains(LOCK_CLASS)) {
      document.body.classList.remove(LOCK_CLASS);
    }
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }

    // Нейтрализуем невидимые полноэкранные fixed-оверлеи Klaviyo,
    // которые остались с pointer-events:auto и перехватывают клики.
    var divs = document.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      var el = divs[i];
      var s = getComputedStyle(el);
      if (
        s.position === 'fixed' &&
        parseInt(s.zIndex, 10) >= 9000 &&
        s.display !== 'none' &&
        s.pointerEvents !== 'none' &&
        parseFloat(s.opacity) === 0
      ) {
        var r = el.getBoundingClientRect();
        if (r.width > window.innerWidth * 0.5 && r.height > window.innerHeight * 0.5) {
          el.style.setProperty('pointer-events', 'none', 'important');
          el.style.setProperty('display', 'none', 'important');
        }
      }
    }
  }

  // Watchdog: запускается, когда на body появляется класс блокировки скролла.
  // Ждёт, пока форма реально откроется (wasOpen), затем ловит её закрытие
  // и, если уборка не произошла, чистит сам. Покрывает ЛЮБОЙ путь закрытия.
  var poller = null;

  function startPoll() {
    if (poller) return;
    var wasOpen = false;
    var ticks = 0;
    poller = setInterval(function () {
      ticks++;
      // класс блокировки уже снят самим Klaviyo — всё хорошо, выходим
      if (!document.body.classList.contains(LOCK_CLASS)) {
        stopPoll();
        return;
      }
      if (klFormOpen()) {
        wasOpen = true;
      } else if (wasOpen) {
        // форма была открыта и закрылась, но класс остался → лечим
        cleanup();
        stopPoll();
      }
      // страховка: класс висит >30с и форма так и не открылась — чистим
      if (ticks > 75 && !wasOpen) {
        cleanup();
        stopPoll();
      }
    }, 400);
  }

  function stopPoll() {
    if (poller) {
      clearInterval(poller);
      poller = null;
    }
  }

  // Следим за изменением класса <body>: класс блокировки добавился → стартуем poll.
  var obs = new MutationObserver(function () {
    if (document.body.classList.contains(LOCK_CLASS)) {
      startPoll();
    }
  });
  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Если класс уже стоит на момент загрузки скрипта — тоже подхватываем.
  if (document.body.classList.contains(LOCK_CLASS)) {
    startPoll();
  }
})();
